import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import TaskManagementTab from './components/TaskManagementTab';
import TaskRelatedLookupTab from './components/TaskRelatedLookupTab';

const { Title } = Typography;

/** 运维工具-TMS「任务工具」：Tab1 任务管理（查询/改状态/途经点）、Tab2 运单/包牌关联任务（只读反查） */
const TaskManagementPage: React.FC = () => {
    const [activeKey, setActiveKey] = useState('task-management');
    const [link, setLink] = useState<{ taskId: number; seq: number }>();

    // Tab2「查看任务详情」→ Tab1 按主键ID查询；seq 递增保证同一 ID 连续点击也能重新触发
    const handleViewTask = (taskId: number) => {
        setLink((prev) => ({ taskId, seq: (prev?.seq ?? 0) + 1 }));
        setActiveKey('task-management');
    };

    return (
        <div className="p-6 space-y-4">
            <Title level={4}>任务工具</Title>
            <Tabs
                className="mt-4"
                activeKey={activeKey}
                onChange={(key) => {
                    // 手动切 Tab 清掉联动条件，重挂载后按默认条件查询；联动跳转走 handleViewTask 不触发 onChange
                    setLink(undefined);
                    setActiveKey(key);
                }}
                destroyInactiveTabPane
                items={[
                    {
                        key: 'task-management',
                        label: '任务管理',
                        children: <TaskManagementTab linkedTaskId={link?.taskId} linkSeq={link?.seq} />,
                    },
                    {
                        key: 'task-related-lookup',
                        label: '运单/包牌关联任务查询',
                        children: <TaskRelatedLookupTab onViewTask={handleViewTask} />,
                    },
                ]}
            />
        </div>
    );
};

export default TaskManagementPage;
